import React from 'react';
import AppBar from 'material-ui/AppBar';
import NavigationChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import IconButton from 'material-ui/IconButton';
import "./PageMenu.css";

// const titleStyle = { 
        // textAlign:'center',
        // fontSize: '1.4rem',
    // }
const barStyle = { 
        height:60,

    }
const buttonStyle = {
    button: {
        // width: 96,
        // height: 96,
        // padding: 24,
    },
    backIcon: {
        width: '2rem',
        height: '2rem',
        marginTop: -6,
        marginLeft: -16,
        marginRight: 0,
    },
  }

const PageMenu = (props) => {

    return (
        <AppBar
            title={props.title}
            iconElementLeft={props.onBackClick !== undefined?<IconButton style={buttonStyle.button} iconStyle={buttonStyle.backIcon}><NavigationChevronLeft/></IconButton>:null}
            iconElementRight={props.menu} showMenuIconButton={props.onBackClick !== undefined}
            onLeftIconButtonTouchTap={props.onBackClick}
            // titleStyle={titleStyle}
            style={barStyle}
            className="backBar"
            iconStyleRight={{ zIndex: 100 }}
        />
    )
};
export default PageMenu;




// WEBPACK FOOTER //
// ./src/components/menu/PageMenu.js